import React from "react";
import { Box, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { MdDiversity3, MdEmail, MdForest, MdHome } from "react-icons/md";
import { NavLink } from "react-router-dom";

const ITEMS = [
  { to: "/", label: "Inicio", icon: MdHome, end: true },
  { to: "/actividades", label: "Actividades", icon: MdDiversity3 },
  { to: "/camp", label: "Camp", icon: MdForest },
  { to: "/contacto", label: "Contacto", icon: MdEmail },
];

const MobileNav = () => (
  <HStack
    as="nav"
    aria-label="Navegación principal"
    display={{ base: "flex", md: "none" }}
    position="fixed"
    bottom="0"
    left="0"
    right="0"
    zIndex="1000"
    gap="0"
    px="2"
    pt="2"
    pb="calc(8px + env(safe-area-inset-bottom))"
    bg="public.bg.panel"
    borderTopWidth="1px"
    borderColor="public.border.subtle"
    boxShadow="0 -10px 30px rgba(28, 35, 48, 0.10)"
    _dark={{ boxShadow: "0 -10px 30px rgba(0, 0, 0, 0.32)" }}
    backdropFilter="blur(16px) saturate(160%)"
  >
    {ITEMS.map((item) => (
      <NavLink key={item.to} to={item.to} end={item.end} style={{ flex: 1, textDecoration: "none" }}>
        {({ isActive }) => (
          <VStack
            position="relative"
            justify="center"
            gap="1"
            minH="56px"
            rounded="16px"
            color={isActive ? "brand.redFg" : "public.fg.muted"}
            bg={isActive ? "brand.redSubtle" : "transparent"}
            _dark={{
              color: isActive ? "gray.100" : "gray.400",
              bg: isActive ? "whiteAlpha.100" : "transparent",
            }}
            transition="background-color 160ms ease, color 160ms ease"
          >
            <Box position="absolute" top="3px" w="20px" h="3px" rounded="full" bg={isActive ? "brand.redFg" : "transparent"} />
            <Icon as={item.icon} boxSize="22px" mt="1" />
            <Text fontSize="10px" lineHeight="1" fontWeight={isActive ? "800" : "650"}>
              {item.label}
            </Text>
          </VStack>
        )}
      </NavLink>
    ))}
  </HStack>
);

export default MobileNav;
